module.exports = __webpack_public_path__ + "img/7X24-hour_service.6aea5a70.jpg";